import { useAppDispatch } from "../../hooks/storeHooks";
import { setActiveTab, setDeficienciesFilters, setGlobalFilterValue } from "../../store/slices/pscSlice";
import { PSCInspection, PSCTabs } from "../../types/psc";
import { classNames } from "primereact/utils";
import { pscDeficienciesFilters } from "../../utils/PSCTableHelper";
import { FilterMatchMode } from "primereact/api";
import { useCallback } from "react";

export const PSCInspectionDeficienciesBody = (item: PSCInspection) => {
    const dispatch = useAppDispatch();
    
    const value = item.number_of_deficiencies;

    const onClick = useCallback(() => {
        if (value) {
            dispatch(setDeficienciesFilters({
                ...pscDeficienciesFilters,
                vessel_name: {
                    value: item.vessel_name,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                inspection_id: {
                    value: item.inspection_id,
                    matchMode: FilterMatchMode.CONTAINS,
                }
            }))
            dispatch(setActiveTab(PSCTabs.deficiencies));
            dispatch(setGlobalFilterValue(""))
        }
    }, [item]);

    return (
        <button 
            className={classNames("psc-table-link-btn", value ? "font-semibold cursor-pointer read-more-btn underline" : null)}
            onClick={onClick}
        >
            {value}
        </button>
    );
}